let baseUrl = 'https://wocup-test.bagherawines.auction/api';
let liveUrl = '';
let socketUrl = 'https://wocup-test.bagherawines.auction/';
let bagheraAuctionUrl = 'https://test.bagherawines.auction';
let imageUrl = 'https://test.bagherawines.auction/';

export { baseUrl, liveUrl, socketUrl, bagheraAuctionUrl, imageUrl };
